import React from "react";
import AuthLayout from "../AuthLayout";

const LoginError = ({ heading, text }) => {
  return (
    <div className="initial-screen-content">
      <h1 style={{ paddingBottom: "20px" }}>{heading}</h1>
      <h3 className="content-title">{text}</h3>
      <p className="mt-4 mb-0">
        Go Back{" "}
        <a href="/login" className="d-inline-block text-blue">
          <u>Login</u>
        </a>
      </p>
    </div>
  );
};
export default AuthLayout()(LoginError);
